module.exports = __webpack_public_path__ + "img/security-codes.11964ca0.svg";